package features.schedule.handlers

import kotlinx.browser.document
import kotlinx.browser.window
import AppState
import Router

/**
 * Handler for switching schedule view mode
 */
fun switchScheduleView(view: String) {
    console.log("🔧 switchScheduleView() called with view:", view)
    
    // Update view state (you may need to add this to AppState)
    // For now, just log it
    console.log("Switching to view:", view)
    
    // Re-render to update the UI
    Router.render()
}
